export default __webpack_public_path__ + "static/header_nieuws-71ebca6ff12bac28d785126762d8af92.webp";